var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selected_device)?_c('div',[_c('button',{staticClass:"btn btn-info",attrs:{"type":"button"},on:{"click":function($event){return _vm.writeToSelectedPrinter();}}},[_c('i',{staticClass:"fas fa-fw fa-print"}),_vm._v(" Label")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }